import s from "./style.module.css";
export interface Input {
    count: number;
}

<div class=s.counter data-counter>
    <for|i| from=0 until=input.count>
        <span class=s.count data-count>
            ${i + 1}
        </span>
    </for>
</div>
